import { ConcreteEncodable } from "./ConcreteEncodable";

import { ControlItemImplEncoder } from "../../encoder/ControlItemImplEncoder";

import * as CubiqTS from "../../index";
import { ControlItem } from "../ControlItem";

export class ControlItemImpl extends ConcreteEncodable implements ControlItem {
  public static enType: string = "com.bcdfx.streaming.ControlItemImpl";

  /*FID=1*/
  public productCode: string;
  /*FID=2*/
  public providerId: number;
  /*FID=3*/
  public tenor: CubiqTS.Tenor;
  /*FID=4*/
  public curveId: string;
  /*FID=5*/
  public date: CubiqTS.moment.Moment | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ControlItemImplEncoder.Instance;
    this.setEncodableType(ControlItemImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ControlItemImpl[" +
      "productCode=" +
      this.productCode +
      "providerId=" +
      this.providerId +
      "tenor=" +
      this.tenor +
      "curveId=" +
      this.curveId +
      "date=" +
      this.date +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
